module.exports = __webpack_public_path__ + "static/img/bg-id.70c66c41.png";